import React from "react";
import type { ComponentType } from "react";
import { AppLayout } from "~/components/Layout/AppLayout";
import { TopNavFallback } from "./TopNavFallback";
import { SideNavFallback } from "./SideNavFallback";
import { PageContentFallback } from "./PageContentFallback";
import "./Fallbacks.css";

type AppShellFallbackProps = {
  ContentFallback?: ComponentType;
};

/** Full app shell placeholder (top + side + content slot). */
export const AppShellFallback: React.FC<AppShellFallbackProps> = ({
  ContentFallback = PageContentFallback,
}) => (
  <AppLayout
    TopNavigation={<TopNavFallback />}
    SideNavigation={<SideNavFallback />}
    SideAction={null}
    PageContent={<ContentFallback />}
  />
);
